import PolicyAdd from '../components/PolicyAdd.vue';
import PolicyEdit from '../components/PolicyEdit.vue';
import PolicyList from '../components/PolicyList.vue';
import BulkRulesEdit from '../components/BulkRulesEdit.vue';
export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: PolicyList,
    meta: {
      title: 'Policy List',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Policies'
        },
        {
          path: 'list',
          title: 'View Policies'
        }
      ]
    }
  },
  {
    path: 'add',
    component: PolicyAdd,
    meta: {
      title: 'Add Policy',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Policies'
        },
        {
          path: 'add',
          title: 'Add Policy'
        }
      ]
    }
  },
  {
    path: 'bulk-rules',
    component: BulkRulesEdit,
    meta: {
      title: 'Bulk Edit Policies',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Policies'
        },
        {
          path: 'bulk-rules',
          title: 'Bulk Edit'
        }
      ]
    }
  },
  {
    path: 'rendering',
    component: () => import('../components/RenderingConfigPage.vue'),
    meta: {
      title: 'Rendering Config',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Policies'
        },
        {
          path: 'rendering',
          title: 'Rendering Config'
        }
      ]
    }
  },
  {
    path: 'ai-triage',
    redirect: '/ai-triage'
  },
  {
    path: ':policy',
    component: PolicyEdit,
    meta: {
      title: 'Edit Policy',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Policies'
        },
        {
          path: '',
          title: 'Edit Policy'
        }
      ]
    }
  }
];
